export default {
    activeMenu(context, payload) {
        context.commit('closeMenu', payload)
    },
    setLoader(context, payload) {
        context.commit('openLoader', payload)
    },
    userData(context, payload) {
        context.commit('userData', payload)
    },
    userPermissions(context, payload) {
        context.commit('userPermissions', payload)
    },


}